//import 'core-js/stable';
//import 'regenerator-runtime/runtime';

import './tag.scss';
import Vue from 'vue';
import Vuex from 'vuex';
import SearchWidget from "./tag/SearchWidget.vue";

//Vue.config.productionTip = false;
Vue.use(Vuex);


const store = new Vuex.Store({
    state: {
        model: null,
        l10n: [],
        fields: new Map(),
        placeholder: '',
        selected: {},
        tags: [], // {field, id, label}
    },
    getters: {
        getValues: (state) => (field, path) => {
            return state.fields.get(field).getVals(path);
        },
    },
    mutations: {
        model(state, payload) {
            state.model = payload;
        },
        l10n(state, payload) {
            state.l10n = payload;
        },
        fields(state, payload) {
            state.fields = new Map(payload);
            state.fields.forEach((val, key) => {
                state.selected[key] = [];
            });
        },
        updateBoolean(state, payload) {
            state.selected[payload.field] = payload.value;
            let tag = {
                uid: payload.field,
                field: payload.field,
                item: {name: state.fieldList[payload.field]},
                path: []
            };
            if (!payload.value) {
                let i = state.tags.findIndex(element => element.uid == (payload.field));
                if (i !== -1) {
                    state.tags.splice(i, 1);
                }
            } else {
                state.tags.push(tag);
            }
        },
        updateSelected(state, payload) {

            let itemId = null;
            let found = null;
            let removed = state.selected[payload.field].filter(x => !payload.value.includes(x));
            let added = payload.value.filter(x => !state.selected[payload.field].includes(x));
            if (removed.length) {
                itemId = removed[0];
            } else if (added.length) {
                itemId = added[0];
            }

            if (typeof payload.item === 'undefined') {
                found = _findAll(state.fields.get(payload.field).vals, itemId)[0];
                // if (!!payload.path) {
                payload.path = found.path;
                // }
            } else {
                found = payload.item;
            }
            let tag = {
                uid: payload.field + '-' + found.id,
                field: payload.field,
                item: found,
                path: payload.path
            };

            if (removed.length) {
                let i = state.tags.findIndex(element => element.uid == (payload.field + '-' + found.id));
                //console.log(i);
                if (i !== -1) {
                    state.tags.splice(i, 1);
                }
            }
            if (added.length) {
                state.tags.push(tag);
            }

            state.selected[payload.field] = payload.value;

            if (payload.field === 'types') {
                if (removed.length) {
                    let currentPath = [];
                    payload.path.forEach(x => {
                        currentPath.push(x);
                        let i = state.selected.types.indexOf(parseInt(x));
                        if (i !== -1) {
                            let p = _findTree(state.fieldValues['Types.id'], currentPath);
                            let children = Object.values(p.children);
                            let difference = children.map(value => value.id).filter(x => !state.selected.types.includes(x));
                            if (p.id !== 1 && (difference.length == 0 || difference[0] == found.id)) {
                                children.forEach(child => {
                                    if (child.id != found.id) {
                                        state.tags.push({
                                            uid: payload.field + '-' + child.id,
                                            field: payload.field,
                                            item: child,
                                            path: currentPath
                                        });
                                    }
                                });
                            }
                            let j = state.tags.findIndex(element => element.uid == ('types-' + p.id));
                            if (j !== -1) {
                                state.tags.splice(j, 1);
                            }
                            state.selected.types.splice(i, 1);
                        }
                    });
                    _removeDescendants(found.children, state.selected.types);
                }
                if (added.length) {
                    _addDescendants(found);
                    _addAncestors(payload.path);
                    _removeDescendantsTag(found.children, state.tags);
                }
            }
        },
        removeSelected(state) {
            Object.keys(state.selected).map(field => {
                let val = [];
                if (field === 'accessible') {
                    val = false;
                }
                state.selected[field] = val;
            });
            state.tags = [];
        },
        addSelected(state, payload) {
            //console.log(payload);

            let selected = [...state.selected[payload.field]];
            let found = _findAll(state.fields.get(payload.field).vals, payload.id);
            // console.log(found);

            found.forEach(item => {
                selected.push(parseInt(item.id));
                store.commit("updateSelected", {
                    field: payload.key,
                    value: selected,
                    item: item,
                    path: item.path
                });
            });

            // state.selected[payload.key].push(payload.id);
        },
    },
});

const _findAll = (iRoot, id, path = []) => {
    let found = [];
    let root = new Map(iRoot);
    //console.log(root);
    root.forEach((val, key) => {
        if (typeof val !== 'object') {
            if (key == id) {
                found.push({
                    id: key,
                    name: val,
                    path
                });
            }
        } else {
            if (val.id == id) {
                val.path = path;
                found.push(val);
            } else if (!!(val.children)) {
                found = found.concat(_findAll(val.children, id, [...path, val.id]));
            }
        }
    });

    return found;
};

/*
const _findTree = (root, iPath) => {
    let path = [...iPath];
    let id = path.shift();
    if (typeof id === 'undefined') {
        return root;
    }
    if (!root.children) {
        root = {
            children: root
        };
    }
    return _findTree(Object.values(root.children).find(item => item.id == parseInt(id)), path);
};
*/
const _removeDescendantsTag = (children, from) => {
    Object.keys(children).map((childKey) => {
        let i = from.findIndex(element => element.uid == ('types-' + children[childKey].id));
        if (i !== -1) {
            from.splice(i, 1);
        }
        _removeDescendantsTag(children[childKey].children, from);
    });
};

const _removeDescendants = (children, from, key = null) => {
    Object.keys(children).map((childKey) => {
        let i = from.findIndex(element => (key ? element[key] : element) == children[childKey].id);
        if (i !== -1) {
            from.splice(i, 1);
        }
        _removeDescendants(children[childKey].children, from);
    });
};

const _addDescendants = (item) => {
    Object.keys(item.children).map((childKey) => {
        if (store.state.selected.types.indexOf(item.children[childKey].id) === -1) {
            //   if (item.id !== 1) {
            store.state.selected.types.push(item.children[childKey].id);
            //   }
            _addDescendants(item.children[childKey]);
        }
    });
};

const _addAncestors = (path) => {
    if (path.length == 0) {
        return;
    }
    let p = _findTree(store.state.fieldValues['Types.id'], path);
    let children = Object.values(p.children).map(value => value.id);
    let difference = children.filter(x => !store.state.selected.types.includes(x));
    if (p.id == 1 || difference.length == 0) {
        store.state.selected.types.push(p.id);
        // add p to tags and remove all descendants from tags
        store.state.tags.push({
            uid: 'types-' + p.id,
            field: 'types',
            item: p,
            path: path
        });
        _removeDescendantsTag(p.children, store.state.tags);

        let last = path.pop();
        if (typeof last !== 'undefined') {
            _addAncestors(path);
        }
    }
};

new Vue({
    el: 'search-widget',
    store,
    components: {
        SearchWidget,
    },
});


$(document).on('hidden.bs.collapse', '.collapse', function () {
    $(this).prev().removeClass('search-card-expanded');
});
$(document).on('show.bs.collapse', '.collapse', function () {
    $(this).prev().addClass('search-card-expanded');
});
